import { z } from 'my-zod'

// Developer Note: These are partial Zod schemas with key information needed from Ordway. For the full API response list, visit: https://ordwaylabs.stoplight.io/docs/ordway

export const ordwayCustomerModel = z.object({
  name: z.string(),
  customerType: z.string(),
  taxExempt: z.boolean(),
  autoPay: z.boolean(),
  id: z.string(),
  paymentTerms: z.string(),
  billingCycleDay: z.string(),
  billingContactEmail: z.string(),
  status: z.string(),
  balance: z.string(),
  currency: z.string(),
  cmrr: z.string(),
  discountedCmrr: z.string(),
  createdDate: z.string(),
  updatedDate: z.string(),
  payNowUrl: z.string(),
  updatePaymentMethodUrl: z.string(),
  openInvoicesUrl: z.string(),
  lastInvoicedAt: z.string(),
  achEnabled: z.boolean()
})

export type ordwayCustomerModel = z.infer<typeof ordwayCustomerModel>

export const ordwayInvoiceModel = z.object({
  id: z.string(),
  customerId: z.string(),
  customerName: z.string(),
  invoiceDate: z.string(),
  dueDate: z.string(),
  subtotal: z.string(),
  invoiceTax: z.string(),
  invoiceAmount: z.string(),
  paidAmount: z.string(),
  balance: z.string(),
  status: z.string(),
  invoicePdfUrl: z.string(),
  currency: z.string(),
  paymentTerms: z.string()
})

export type ordwayInvoiceModel = z.infer<typeof ordwayInvoiceModel>
